/* eslint-disable */
import { Grid, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';
import React from 'react';
import { compose } from 'recompose';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import DisclaimerPropTypes from './Disclaimer.component.props';
import activityLogStyles from './Disclaimer.component.styles';

/**
 * Disclaimer
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const Disclaimer = ({ classes }) => {
  return (
    <Grid alignItems="center" container spacing={2}>
      <Grid item>
        <Grid alignItems="center" className={classes.flexWrapNowrap} container spacing={2}>
          <Grid item>
            <WarningIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
          </Grid>
          <Grid className={classes.flexGrow1} item>
            <Typography variant="caption">
              Report data shown for information purposes only. Please refer to your Boral Tax Invoice for final fees and charges
            </Typography>
          </Grid>
        </Grid>
        <Grid alignItems="center" className={classes.flexWrapNowrap} container spacing={2}>
          <Grid item>
            <WarningIcon className={classNames(classes.nakedIcon, classes.warningIcon)} />
          </Grid>
          <Grid className={classes.flexGrow1} item>
            <Typography variant="caption">Information subject to change where applicable</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Disclaimer.propTypes = DisclaimerPropTypes;

export default compose(withStyles(themeCreateInjectableStyles(activityLogStyles), { withTheme: true }))(Disclaimer);
